<template>
  <button
    :class="buttonClass"
    v-bind="$attrs"
    ds-component="DsChip"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <span class="ds-chip__title">
      {{ title }}
    </span>
    <DsIcon
      v-if="icon"
      :name="name"
      size="small"
    />
  </button>
</template>

<script>
import { DsIcon } from '@ds/icons';

export default {
  name: 'OnboardingChips',
  components: {
    DsIcon,
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'normal',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    icon: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    dark: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      validTypes: [
        'normal',
        'addable',
        'removable',
      ],
    };
  },
  computed: {
    getType() {
      // @ts-ignore
      return this.validTypes.includes(this.type) ? this.type : this.validTypes[0];
    },
    buttonClass() {
      return [
        'ds-chip',
        // @ts-ignore
        `ds-chip--${this.getType}`,
        this.icon ? 'ds-chip--icon' : '',
      ];
    },
  },
  mounted() {
    document.documentElement.setAttribute(
      'data-color-theme',
      // @ts-ignore
      this.dark ? 'dark' : ''
    );
  },
};
</script>

<style lang="scss" scoped>
.ds-chip {
  border-radius: var(--ds-spacing-stack-sm);
  border-width: 0;
  display: flex;
  font-weight: var(--ds-font-weight-regular);
  font-size: var(--ds-font-size-xs);
  line-height: var(--ds-font-line-height-normal);
  padding: var(--ds-spacing-inset-quark) var(--ds-spacing-inset-nano);
  font-family: var(--ds-font-family);
}

.ds-chip--normal {
  background-color: var(--ds-color-overlay);
  box-shadow: 0 0 0 1px var(--ds-color-gray-1) inset;
  color: var(--ds-color-text-1);

  &:disabled {
    box-shadow: 0 0 0 1px var(--ds-color-overlay) inset;
    background-color: var(--ds-color-overlay);
    color: var(--ds-color-text-mid);
  }

  .ds-icon {
    background-color: var(--ds-color-text-1);
  }
}

.ds-chip--addable {
  background: transparent;
  box-shadow: 0 0 0 1px var(--ds-color-interactive) inset;
  color: var(--ds-color-interactive);

  .ds-icon {
    background-color: var(--ds-color-interactive);
  }
}

.ds-chip--removable {
  background: var(--ds-color-interactive);
  box-shadow: 0 0 0 1px var(--ds-color-interactive) inset;
  color: var(--ds-color-white);

  .ds-icon {
    background-color: var(--ds-color-white);
  }
}

.ds-chip--icon {
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 318px;
    white-space: nowrap;
  }

  .ds-icon {
    font-size: var(--ds-font-size-xs);
    margin-left: var(--ds-spacing-stack-nano);
  }
}
</style>
